import { styled } from '@zoopla-eng/zds-components/themes';
import { Button } from '@zoopla-eng/zds-components/button';

export const StyledLegend = styled('legend', {
    fontGroup: 'ladle',
    fontWeight: '$400'
});

export const StyledLabel = styled('label', {
    fontGroup: 'ladle'
});

export const StyledRadioButton = styled(Button, {
    fontWeight: '$200',
    '--colors-tmp-success': '#007700',
    '--colors-tmp-error': '#CC0000',
    '&[aria-checked="true"]': {
        color: '$white'
    },
    variants: {
        variant: {
            unified: {
                '&[aria-checked="true"]': {
                    bg: '$buttonSecondaryBackgroundActive',
                    color: '$buttonSecondaryTextActive'
                }
            },
            yes: {
                '&:not([disabled]):not([aria-disabled="true"]):not([data-loading="true"]):hover, &[aria-checked="true"]':
                    {
                        bg: '$tmp-success'
                    }
            },
            no: {
                '&:not([disabled]):not([aria-disabled="true"]):not([data-loading="true"]):hover, &[aria-checked="true"]':
                    {
                        bg: '$tmp-error'
                    }
            }
        },
        error: {
            true: {
                borderColor: '$functionalError'
            }
        }
    }
});

export const StyledError = styled('p', {
    fontGroup: 'fork',
    color: '$functionalError'
});
